"use strict";

let missingTranslations = [];

export function translate(string) {
    if (typeof _translations !== 'object') {
        console.error('Global translation object _translations missing');
        return string;
    }

    if (!_translations[string]) {
        console.warn('Could not translate "' + string + '". Translation not found in translation object', _translations)
        missingTranslations.push(string);
        return string;
    }

    return _translations[string];
}

export function getMissingTranslations() {
    return missingTranslations;
}

window.getMissingTranslations = getMissingTranslations;